/**
 * Service für Kellner-Rufe
 * Zentralisiert alle Funktionen rund um das Thema Kellner-Rufe
 */

import { instance } from '@/services/api/index';

/**
 * Ruft den Kellner für eine Session auf
 * @param {string} sessionId - ID der Session
 * @returns {Promise<object>} - Antwort vom Server
 */
export const callWaiterBySession = async (sessionId) => {
  if (!sessionId) {
    throw new Error('Session-ID ist erforderlich');
  }

  console.log(`Rufe Kellner für Session ${sessionId} auf`);
  try {
    const response = await instance.post(`/OrderSessions/${sessionId}/call-waiter`);
    return response.data;
  } catch (error) {
    console.error('Fehler beim Rufen des Kellners:', error);
    throw error;
  }
};

/**
 * Bestätigt einen Kellner-Ruf (vom Kellner/Admin)
 * @param {string} sessionId - ID der Session
 * @returns {Promise<object>} - Antwort vom Server
 */
export const acknowledgeWaiterCall = async (sessionId) => {
  if (!sessionId) {
    throw new Error('Session-ID ist erforderlich');
  }

  console.log(`Bestätige Kellner-Ruf für Session ${sessionId}`);
  try {
    const response = await instance.post(`/OrderSessions/${sessionId}/acknowledge-waiter-call`);
    return response.data;
  } catch (error) {
    console.error(`Fehler beim Bestätigen des Kellner-Rufs für Session ${sessionId}:`, error);
    throw error;
  }
};

/**
 * Ruft den Status des Kellner-Rufs ab
 * @param {string} sessionId - ID der Session
 * @returns {Promise<object>} - Status des Kellner-Rufs
 */
export const getWaiterCallStatus = async (sessionId) => {
  if (!sessionId) {
    throw new Error('Session-ID ist erforderlich');
  }

  try {
    const response = await instance.get(`/OrderSessions/${sessionId}/waiter-call-status`);
    return response.data;
  } catch (error) {
    console.error(`Fehler beim Abrufen des Kellner-Ruf-Status für Session ${sessionId}:`, error);
    throw error;
  }
};

export const waiterCallService = {
  callWaiterBySession,
  acknowledgeWaiterCall,
  getWaiterCallStatus
};
